import { useTranslation } from "react-i18next";
import type { StatusIndicator } from "../types";
import { getStatusVariant } from "../utils";
import { Badge, type BadgeProps } from "../../badge";

export interface LabStatusBadgeProps extends Omit<BadgeProps, "children" | "variant"> {
  indicator?: StatusIndicator;
}

export const LabStatusBadge = ({ indicator, ...props }: LabStatusBadgeProps) => {
  const { t } = useTranslation("ui");

  const getLabel = (indicator?: StatusIndicator): string => {
    if (!indicator) return t("Recorded");
    if (indicator === "H") return t("High");
    if (indicator === "L") return t("Low");
    return t("In Range");
  };

  const label = getLabel(indicator);
  const variant = getStatusVariant(indicator);

  return (
    <Badge data-slot="lab-status-badge" variant={variant} {...props}>
      {label}
    </Badge>
  );
};
